import React, { useState, useEffect } from 'react';
import {
    BrowserRouter as Router,
    Link,
    useLocation,
    withRouter
} from "react-router-dom";

import Slider from 'react-slick';
import SoldIcon from '../sold-icon';
import StatusIcon from '../status-icon/status-icon';
import ListingFeedback from '../listing-feedback/listing-feedback';
import Modal from '../modal';
import UserForm from '../user-form';
import HOne from '../h-one';
import OfferResale from '../offer-resale';
import OfferResaleTableTr from '../offer-resale-table-tr';

import Parser from "html-react-parser";
import StringProcessingService from '../../services/string-processing-service';
import ConfigurationService from '../../services/configuration-service';
import ServerApi from '../../services/server-api-service';

import '../offers-grid/offers-grid-style.css';
import './offer-resale-grid-style.css';
import '../../lib/slick-1.8.1/slick.css';
import '../../lib/slick-1.8.1/slick-theme.css';

import { AnimatePresence, motion } from 'framer-motion';

function OfferResaleGrid(props) {

    let { children,
        saveState,
        dictionary,
        width,
        limit,
        resales = false,
        projectData,
        internalLink = true,
        mobileVerison,
        tableView = false } = props;
    let data = projectData.listings

    const location = useLocation();
    const [visibleCount, setVisibleCount] = useState(3);

    const [stepCount, setStepCount] = useState(4);
    const [moreStep, setMoreStep] = useState(1);
    const [tableVisible, setTableVisible] = useState(false);
    const [openCounts, setOpenCounts] = useState(1);
    const [tableExpanded, setTableExpanded] = useState(false);
    const pageTransition = {
        in: {
            opacity: 1
        },
        out: {
            opacity: 0
        }
    }

    const stringProcessingService = new StringProcessingService();

    const queryParams = new URLSearchParams(location.search);

    const desc = queryParams.get('desc');
    const viewDetailsColor = queryParams.get('view_details');
    let additionalOffers = [];


    if (limit === undefined && data) {
        limit = data.length
    }
    // useEffect(()=>{
    //     if(mobileVerison == true) {
    //         setAdditionalCounter(additionalCounter - 1); 
    //         setOpenCounts(3);
    //     }
    //     else {
    //         setAdditionalCounter(additionalCounter + 1);
    //         setOpenCounts(4);
    //     }
    // },[mobileVerison])

    const resize = () => {
        if (width > 1430) {
            setStepCount(8);
            if(tableView)  setStepCount(4);
        } else if (width < 1430 && width > 1070) {
            setStepCount(9);
            if(tableView)  setStepCount(3);
        } else if (width < 1070 && width > 720) {
            setStepCount(6);
            if(tableView)  setStepCount(4);
        }
        else if (width < 720) {
            setStepCount(6);
            if(tableView)  setStepCount(4);
        }
        setVisibleCount(stepCount * moreStep);
    }

    useEffect(() => {
        resize();
    })


    useEffect(() => {
        if (desc && desc == 'true') {

            data = data.sort((a, b) => {
                if (b.DealRank !== a.DealRank) return b.DealRank - a.DealRank;
                return b.ListPrice - a.ListPrice;
            });

        } else {
            data = data.sort((a, b) => {
                if (b.DealRank !== a.DealRank) return b.DealRank - a.DealRank;
                return a.ListPrice - b.ListPrice;
            });
        }
    }, [])

    useEffect(() => {
        resize();
    }, [width])
    // let offers;
    // if (data !== undefined && data.main_block.length > 0) {

    //     offers = data.main_block.map((item, index) => {
    //         return (
    //                 <motion.div
    //                     variants={pageTransition}
    //                     exit="out"
    //                     animate="in"
    //                     initial="out"
    //                                 >
    //                     <OfferResale
    //                         data={item}
    //                         key={item.id}
    //                         dictionary={dictionary}
    //                         width={width}
    //                         saveState={saveState}
    //                         resales={resales}
    //                         projectData={projectData}
    //                         internalLink={internalLink}
    //                     />
    //                 </motion.div>
    //             )
    //     })
    // }




    const openMore = () => {
        setMoreStep(prev => {
            const next = prev + 1;
            setVisibleCount(stepCount * next);
            return next;
        });
    }

    const openMoreTable = () => {
        setTableExpanded(true);
    }

    const renderOffers = () => {
        if (tableView) {

            let mainPart = [];
            let additionalPart = [];

            if (data !== undefined && data.length > 0) {
                data.slice(0, stepCount).map((item, index) => {
                    mainPart.push(
                        <motion.div
                            key={item.id}
                            variants={pageTransition}
                            exit="out"
                            animate="in"
                            initial="out"
                        >
                            <OfferResale
                                data={item}
                                dictionary={dictionary}
                                width={width}
                                saveState={saveState}
                                resales={resales}
                                projectData={projectData}
                                internalLink={internalLink}
                                viewDetailsColor={viewDetailsColor}
                            />
                        </motion.div>
                    )
                });
                additionalPart = data.slice(stepCount, data.length).sort((a, b) => a.BedroomsTotal - b.BedroomsTotal);

            }



            const displayedAdditional = additionalPart;

            const FootageWords = dictionary.footage.split(' ');
            let UnitWords = Array.from(dictionary.unit_number.split(' '));
            let UnitLastWord ='';
            if (UnitWords.length > 2) {
                UnitLastWord = UnitWords[UnitWords.length - 1];
                UnitWords.pop();
            }

            let ListingPriceWords = Array.from(dictionary.listing_price.split(' '));
            let ListingPriceLastWord = ListingPriceWords[ListingPriceWords.length - 1];
            ListingPriceWords.pop();

            let PricePerSqftWords = Array.from(dictionary.price_per_sqft.split(' '));
            let PricePerSqftLastWord = PricePerSqftWords[PricePerSqftWords.length - 1];
            PricePerSqftWords.pop();

            return (
                <>
                    <div className='OfferResaleGrid'>
                        {mainPart}
                    </div>
                    {children}

                    {additionalPart.length > 0 && (
                        <div className={`OfferResaleTableWrapper ${tableExpanded ? 'expanded' : 'collapsed'}`}>
                            <table className='OfferResaleTable'>
                            <colgroup>
                                <col style={{ width: '17%' }} />
                                <col style={{ width: '10%' }} />
                                <col style={{ width: '16%' }} />
                                <col style={{ width: '21%' }} />
                                <col style={{ width: '13%' }} />
                                <col style={{ width: '16%' }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    {width < 800 ? (
                                        <>

                                            <th style={{ textAlign: 'left'}}>
                                                 <span>
                                                    {UnitWords.join(' ')}
                                                    <br />
                                                    {UnitLastWord}
                                                </span>
                                                
                                            </th>
                                            <th style={{ textAlign: 'right' }}>{dictionary.baths}</th>
                                            <th style={{ textAlign: 'right'}}>
                                                 <span>{dictionary.area}</span>
                                            </th>

                                            <th style={{ textAlign: 'right'}}>
                                                <span>
                                                    {ListingPriceWords.length > 0 ? (
                                                        <>
                                                            {ListingPriceWords.join(' ')}
                                                            <br />
                                                            {ListingPriceLastWord}
                                                        </>
                                                    ): ListingPriceLastWord}
                                                </span>
                                            </th>

                                            <th style={{ textAlign: 'right'}}>
                                                <span>

                                                    {PricePerSqftWords.join(' ')}
                                                    <br />
                                                    {PricePerSqftLastWord}
                                                </span>
                                            </th>
                                            <th></th>
                                        </>
                                    ) : (
                                        <>

                                            <th style={{ textAlign: 'left', }}>{dictionary.unit_number}</th>
                                            <th style={{ textAlign: 'right' }}>{dictionary.bathrooms}</th>
                                            <th style={{ textAlign: 'right'}}>{dictionary.footage}</th>

                                            <th style={{ textAlign: 'right'}}>
                                                <span>{dictionary.listing_price} </span>
                                            </th>

                                            <th style={{ textAlign: 'right'}}>
                                                <span>{dictionary.price_per_sqft}</span>
                                            </th>
                                            <th></th>
                                        </>

                                    )}

                                </tr>
                            </thead>
                            <tbody>
                                {displayedAdditional.map((item, index) => {

                                    return (<OfferResaleTableTr
                                        key={item.id}
                                        index={index}
                                        item={item}
                                        dictionary={dictionary}
                                        width={width}
                                        projectData={projectData}
                                        stringProcessingService={stringProcessingService}
                                        displayedAdditional={displayedAdditional}
                                    />
                                    )
                                })}
                            </tbody>
                        </table>
                        
                        {!tableExpanded && additionalPart.length > 0 && (
                            <div className='OfferResaleTableOverlay'>
                                <div className='OfferResaleTableFade'></div>
                                <div className='OfferResaleViewMoreContainer'>
                                    <div id="ResaleMoreBtn" className='Button' onClick={openMoreTable}>{dictionary.view_more.toUpperCase()}</div>
                                </div>
                            </div>
                        )}
                        </div>
                    )}
                </>
            )

        } else {

            let additionalOffers = [];

            if (data !== undefined && data.length > 0) {

                // additionalOffers = data.map((item, index) => {
                //     return 
                // })

                for (let index = 0; index < visibleCount && index < data.length; index++) {
                    additionalOffers.push(
                        (<motion.div
                            variants={pageTransition}
                            exit="out"
                            animate="in"
                            initial="out"
                        >
                            <OfferResale
                                data={data[index]}
                                key={data[index].id}
                                dictionary={dictionary}
                                width={width}
                                saveState={saveState}
                                resales={resales}
                                projectData={projectData}
                                internalLink={internalLink}
                               
                            />
                        </motion.div>
                        )
                    )

                }
            }

            return (
                <>

                    <div className='OfferResaleGrid'>
                        {/* {offers} */}
                        {additionalOffers}

                    </div>
                    <br />
                    {visibleCount < data.length ? (
                        <div style={{ width: '100%', textAlign: 'center' }}>
                            <div id="ResaleMoreBtn" className=' Button' onClick={openMore}>{dictionary.view_more.toUpperCase()}</div>
                        </div>
                    ) : null}
                </>
            )

        }
    }



    if (data.length == 0) return null;

    return (
        <>
            {renderOffers()}
        </>
    )
}

export default OfferResaleGrid;